import assetsReducer from "./reducer"
import assetsSaga from "./sagas"

const saga = {
  reducers: assetsReducer,
  sagas: assetsSaga
}

export default saga